<itl-image
  [title]="'woundMeasure.imageTitle' | translate"
  [description]="'woundMeasure.imageDescription' | translate"
  [required]="node.mandatory"
  (addImageButtonClicked)="addImage()"
  [showUploadButton]="images.length === 0"
  [buttonText]="'woundMeasure.modalTitle' | translate"
>
  <div *ngFor="let image of images; let i = index" class="node-image">
    <img [src]="image.data" width="100" height="100" class="padding" style="margin: 5px;" />
  </div>

  <span *ngIf="images.length > 0">
    <itl-button (click)="showEditMeasureModal()" class="modal-button"
      >{{'woundMeasure.measureImageButtonText' | translate}}</itl-button
    >
    <itl-button (click)="deleteImage()" class="modal-button"
      >{{'woundMeasure.resetImageButtonText' | translate}}</itl-button
    >
  </span>
</itl-image>

<input
  #file
  type="file"
  name="name"
  accept=".jpg,.png"
  style="display: none;"
  (change)="handleFileOpenDialog($event)"
/>
